module.exports = __webpack_public_path__ + "img/p5.57c53e05.png";